/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-11-26 12:47:49                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-01-27 13:20:04                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * Services
  * Validator
  * QuotationPricingForm: Quotation pricing form 
*/

/* Imports */
import { t } from "i18next";
import { useState } from "react";
/***/

/* Services */
import { validator } from "../../../services/form-validator/form-validator";
/***/

/* Validator */
export const QuotationPricingFormValidator = {
  partsCost: (e: unknown) => validator.isNumber(e),
  servicesCost: (e: unknown) => validator.isNumber(e),
  techFees: (e: unknown) => validator.isNumber(e),
  estimatedCost: (e: unknown) => validator.isNumber(e),
  techBasePrice: (e: unknown) => validator.isNumber(e)
};

const v = QuotationPricingFormValidator; // shorthand
/***/

/**
* QuotationPricingForm: Quotation pricing form 
* @param data - Data to edit
* @param onChange - On change event, trigger on field change
* @param onSubmit - On submit event, trigger enter key down on field
* @param submitted - is form submitted
*/
export default function QuotationPricingForm({
  data,
  onChange,
  onSubmit,
  submitted
}: {
  data?: EasyTech.QuotationPricing,
  onChange: (name: string, value: any) => void,
  onSubmit: () => void,
  submitted?: boolean
}) {
  const [dataState, setDataState] = useState<EasyTech.QuotationPricing>(data || {} as EasyTech.QuotationPricing);

  /**
  * handleChange: handle field change event
  * @param name - field name
  * @param value - param value 
  */
  const handleChange = (name: string, value: any) => {
    const tmp = {...dataState};
    tmp[name] = value;
    setDataState(tmp);
    onChange(name, value);
  };
  /***/

  return (
    <>
      <div className="field">
        <label>{t("Parts cost")} *</label>
        <input  value={dataState.partsCost}
                type="number"
                placeholder="$"
                onChange={(e) => handleChange("partsCost", Number(e.target.value))}
                className={`form-field ${(submitted && !validator.isFieldValid(data, "partsCost", v)) && "error"}`}/>
      </div>

      <div className="field">
        <label>{t("Services cost")} *</label>
        <input  value={dataState.servicesCost}
                type="number"
                placeholder="$"
                onChange={(e) => handleChange("servicesCost", Number(e.target.value))}
                className={`form-field ${(submitted && !validator.isFieldValid(data, "servicesCost", v)) && "error"}`}/>
      </div>

      <div className="field">
        <label>{t("Technician fees")} *</label>
        <input  value={dataState.techFees}
                type="number"
                placeholder="$"
                onChange={(e) => handleChange("techFees", Number(e.target.value))}
                className={`form-field ${(submitted && !validator.isFieldValid(data, "techFees", v)) && "error"}`}/>
      </div>

      <div className="field">
        <label>{t("Estimated cost")} *</label>
        <input  value={dataState.estimatedCost}
                type="number"
                placeholder="$"
                onChange={(e) => handleChange("estimatedCost", Number(e.target.value))}
                className={`form-field ${(submitted && !validator.isFieldValid(data, "estimatedCost", v)) && "error"}`}/>
      </div>

      <div className="field">
        <label>{t("Technician base price")} *</label>
        <input  value={dataState.techBasePrice}
                type="number"
                placeholder="$"
                onChange={(e) => handleChange("techBasePrice", Number(e.target.value))}
                className={`form-field ${(submitted && !validator.isFieldValid(data, "techBasePrice", v)) && "error"}`}/>
      </div>
    </>
  );
}
/***/
